<template>
  <footer>
    <div class="breadcrumbs livenex--inner">
      <ul>
        <li v-for="(link, i) in breadcrumbs" :key="i">
          <a v-if="link.link" href="javascript:void(0)" @click="moveView(link)">{{ $t("breadCrumb." + link.name) }}</a>
          <label v-if="!link.link">{{ $t("breadCrumb." + link.name) }}</label>
        </li>
      </ul>
    </div>
    <div class="maincont">
      <span v-if="pearlsOfWisdom" id="btnpopup" class="popup-modal" href="#popup-add" @click="openWisdom"></span>
      <a href="#" id="totop"></a>
      <div class="jms--wrapper">
        <ul class="menuhover">
          <li>
            <router-link :to="{name: 'Service'}">
              サービス概要
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'Company'}">
              運営会社
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'PrivacyPolicy'}">
              プライバシーポリシー
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'SitePolicy'}">
              サイトポリシー
            </router-link>
          </li>
          <!-- <li>
            <router-link :to="{ name: 'ImproveGround' }">
              地盤改良の重要性
            </router-link>
          </li> -->
          <li>
            <router-link :to="{name: 'Terms'}">
              利用規約
            </router-link>
          </li>
          <li>
            <a @click="openOtherWindow('Contact')" class="cursor">
              お問い合わせ
            </a>
          </li>
          <li>
            <a v-if="manualDispFlg" href="https://itshouse.zendesk.com/hc/ja" target="_blank">操作マニュアル</a>
          </li>
        </ul>
        <p class="copy">&copy;it's HOUSE Co.,Ltd. All rights reserved.</p>
      </div>
    </div>
    <magnific-popup-modal :show="false" :config="modalOption" :modalStyle="{id: 'popup-add', class: 'contentpopup add'}" ref="pealrsWisdom">
      <div>
        <dl>
          <dt>知恵袋</dt>
          <dd>
            <span v-if="$route && $route.name != null && $route.name != undefined">
              {{ $route.name }}
            </span>
            画面の知恵袋
          </dd>
        </dl>
      </div>
    </magnific-popup-modal>
  </footer>
</template>

<script>
import magnificPopupModal from "@/components/parts/MagnificPopupModal.vue";
import constConfig from "@/common/const";
export default {
  data() {
    return {
      breadcrumbs: [],
      modalOption: constConfig.MODAL_OPTION,
      manualDispFlg: this.$store.state.manualDispFlg,
    };
  },
  components: {
    "magnific-popup-modal": magnificPopupModal,
  },
  computed: {
    pearlsOfWisdom: function() {
      //知恵袋表示しない画面
      let noneWisdom = [null, "MailAddress", "PasswordEdit", "MemberInfoRegist", "Notice", "NoticeDetail", "Contact", "Error", "Service", "Basicstructure", "Standardspecifications", "Company", "Terms", "PrivacyPolicy", "SitePolicy", "Reservation", "Top", "SearchPlan", "ConstructInput", "PlanDetail", "PlanComplete", "SavedPlanList", "SavedPlanDetail", "SavedPlanDeleteComplete", "SavedPlanUpdateComplete", "DocumentOffer", "DocumentDownload", "DocumentUpload", "MovingQuotation", "Contract", "FinancingPlan", "SnsPolicy", "PasswordReissue", "Schedule", "ViaLogin", "ImproveGround", "completeWitness", "Transfer", "LivPlanList", "VarysLineUp", "VarysFloor", "MailAuthKeyExpired", "StandardSpecificationsVarys", "StoreList"];
      if (noneWisdom.includes(this.$route.name)) {
        return false;
      } else {
        return true;
      }
    },
  },
  created: function() {
    if (this.$route.name) this.setBreadCrumb(this.$route, null);
  },

  watch: {
    $route: "setBreadCrumb",
  },
  methods: {
    setBreadCrumb: function(to, from) {
      if (to.name == undefined) {
        this.breadcrumbs = [];
        this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_TOP, false));
      } else {
        switch (to.name) {
          // TOP画面
          case constConfig.VIEW_TOP.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_TOP, false));
            break;
          // エラー
          case "Error":
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_TOP, false));
            break;
          //有効期限切れ
          case constConfig.VIEW_MAILAUTHKEY_EXPIRED.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_TOP, false));
            break;
          // 建築地入力
          case constConfig.VIEW_CONSTRUCT_INPUT.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_TOP, true));
            if (from.name == constConfig.VIEW_SEARCH_PLAN.name) {
              this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SEARCH_PLAN, true));
            }
            var constr = {
              name: constConfig.VIEW_CONSTRUCT_INPUT.name,
              params: {
                planId: to.params.planId,
                specDiv: to.params.specDiv,
                entranceDirectionCd: to.params.entranceDirectionCd,
              },
            };
            this.breadcrumbs.push(this.addBreadCrumb(constr, false));
            break;
          // 基本プラン詳細
          case constConfig.VIEW_PLAN_DETAIL.name:
            if (from && (from.name == constConfig.VIEW_SEARCH_PLAN.name || from.name == constConfig.VIEW_CONSTRUCT_INPUT.name)) {
              this.breadcrumbs.forEach((bc) => {
                bc.link = true;
              });
            } else {
              this.breadcrumbs = [];
              this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_TOP, true));
            }
            var planDetail = {
              name: constConfig.VIEW_PLAN_DETAIL.name,
              query: {planId: to.params.planId},
            };
            this.breadcrumbs.push(this.addBreadCrumb(planDetail, false));
            break;
          // お知らせ詳細
          case constConfig.VIEW_NOTICE_DETAIL.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_TOP, true));
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_NOTICE, true));
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_NOTICE_DETAIL, false));
            break;
          // お問い合わせ
          case constConfig.VIEW_CONTACT.name:
            this.breadcrumbs = [];
            break;
          // マイページ
          case constConfig.VIEW_SAVED_PLAN_LIST.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, false));
            break;
          // 保存済みプラン詳細
          case constConfig.VIEW_SAVED_PLAN_DETAIL.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            var savedPlanDetail = {
              name: constConfig.VIEW_SAVED_PLAN_DETAIL.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(savedPlanDetail, false));
            break;
          // 資金計画
          case constConfig.VIEW_FINANCING_PLAN.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            savedPlanDetail = {
              name: constConfig.VIEW_SAVED_PLAN_DETAIL.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(savedPlanDetail, true));

            var financingPlan = {
              name: constConfig.VIEW_FINANCING_PLAN.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(financingPlan, false));
            break;
          // 契約書類作成依頼
          case constConfig.VIEW_DOCUMENT_OFFER.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            savedPlanDetail = {
              name: constConfig.VIEW_SAVED_PLAN_DETAIL.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(savedPlanDetail, true));

            financingPlan = {
              name: constConfig.VIEW_FINANCING_PLAN.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(financingPlan, true));

            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_DOCUMENT_OFFER, false));
            break;
          // 引越正式見積依頼
          case constConfig.VIEW_MOVING_QUOTATION.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            savedPlanDetail = {
              name: constConfig.VIEW_SAVED_PLAN_DETAIL.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(savedPlanDetail, true));

            financingPlan = {
              name: constConfig.VIEW_FINANCING_PLAN.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(financingPlan, true));

            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_MOVING_QUOTATION, false));
            break;
          // シミュレーション削除完了
          case constConfig.VIEW_PLAN_DELETE_COMPLETE.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_PLAN_DELETE_COMPLETE, false));
            break;
          // シミュレーション更新完了
          case constConfig.VIEW_PLAN_UPDATE_COMPLETE.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_PLAN_UPDATE_COMPLETE, false));
            break;
          // 契約申込
          case constConfig.VIEW_CONTRACT.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            savedPlanDetail = {
              name: constConfig.VIEW_SAVED_PLAN_DETAIL.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(savedPlanDetail, true));

            var contract = {
              name: constConfig.VIEW_CONTRACT.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(contract, false));
            break;
          // 資金計画
          case constConfig.VIEW_DOCUMENT_DOWNLOAD.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            savedPlanDetail = {
              name: constConfig.VIEW_SAVED_PLAN_DETAIL.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(savedPlanDetail, true));

            var documentDownload = {
              name: constConfig.VIEW_FINANCING_PLAN.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(documentDownload, false));
            break;

          // 資金計画
          case constConfig.VIEW_DOCUMENT_UPLOAD.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            savedPlanDetail = {
              name: constConfig.VIEW_SAVED_PLAN_DETAIL.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(savedPlanDetail, true));

            var documentUpload = {
              name: constConfig.VIEW_FINANCING_PLAN.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(documentUpload, false));
            break;

          // スケジュール管理
          case constConfig.VIEW_SCHEDULE.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            savedPlanDetail = {
              name: constConfig.VIEW_SAVED_PLAN_DETAIL.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(savedPlanDetail, true));

            var schedule = {
              name: constConfig.VIEW_SCHEDULE.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(schedule, false));
            break;
          // ログイン（経由）
          case constConfig.VIEW_VIA_LOGIN.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_TOP, true));
            break;
          // 完成立会確認書
          case constConfig.VIEW_COMPLETEWITNESS.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            savedPlanDetail = {
              name: constConfig.VIEW_SAVED_PLAN_DETAIL.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(savedPlanDetail, true));

            var completeWitness = {
              name: constConfig.VIEW_COMPLETEWITNESS.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(completeWitness, false));
            break;
          // 建築建物引渡書
          case constConfig.VIEW_TRANSFER.name:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_SAVED_PLAN_LIST, true));
            savedPlanDetail = {
              name: constConfig.VIEW_SAVED_PLAN_DETAIL.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(savedPlanDetail, true));

            var transfer = {
              name: constConfig.VIEW_TRANSFER.name,
              query: {simulationNo: to.query.simulationNo},
            };
            this.breadcrumbs.push(this.addBreadCrumb(transfer, false));
            break;
          // デフォルト（Top > 表示画面名）
          default:
            this.breadcrumbs = [];
            this.breadcrumbs.push(this.addBreadCrumb(constConfig.VIEW_TOP, true));
            this.breadcrumbs.push(this.addBreadCrumb(this.getViewInfo(to), false));
            break;
        }
      }
    },
    // パンくずメニューからの遷移
    moveView: function(viewInfo) {
      if (viewInfo.name == constConfig.VIEW_CONSTRUCT_INPUT.name) {
        // 建築地入力：パラメータ（params:planId）を設定
        this.$router.push({
          name: viewInfo.name,
          params: {
            planId: viewInfo.params.planId,
            specDiv: viewInfo.params.specDiv,
            entranceDirectionCd: viewInfo.params.entranceDirectionCd,
          },
        });
      } else if (
        // 保存済みプラン、資金計画：パラメータ（query:simulationNo）を設定
        viewInfo.name == constConfig.VIEW_SAVED_PLAN_DETAIL.name ||
        viewInfo.name == constConfig.VIEW_FINANCING_PLAN.name
      ) {
        this.$router.push({
          name: viewInfo.name,
          query: {simulationNo: viewInfo.query.simulationNo},
        });
      } else {
        this.$router.push({name: viewInfo.name});
      }
    },
    openWisdom: function() {
      // eslint-disable-line no-unused-vars
      this.$refs.pealrsWisdom.open();
    },
  },
};
</script>

<style lang="scss"></style>
